import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
      <div className="prose max-w-none">
        <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
        <p>When you visit Marine Fuel Boost, we collect:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Information you provide when making a purchase</li>
          <li>Usage data and analytics</li>
          <li>Technical information about your device</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Process your orders</li>
          <li>Improve our products and services</li>
          <li>Send you important updates</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Data Security</h2>
        <p>We implement appropriate security measures to protect your personal information.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Your Rights</h2>
        <p>You have the right to:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Access your personal data</li>
          <li>Request corrections</li>
          <li>Request deletion</li>
          <li>Withdraw consent</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Contact Us</h2>
        <p>For privacy-related inquiries, please contact us at support@marinefuelboost.com</p>
      </div>
    </div>
  );
} 